"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiButtonGroupOverrides = function (_a) {
    var _b, _c;
    var spacing = _a.spacing, breakpoints = _a.breakpoints;
    return ({
        root: (_b = {
                minWidth: spacing(30)
            },
            _b[breakpoints.only("xl")] = {
                minWidth: spacing(50),
            },
            _b),
        contained: {
            boxShadow: "",
        },
        grouped: (_c = {
                minWidth: spacing(10)
            },
            _c[breakpoints.only("xl")] = {
                minWidth: spacing(12),
            },
            _c),
        groupedHorizontal: {
            flexGrow: 1,
        },
        groupedContainedHorizontal: {
            "&:not(:last-child)": {
                borderRight: undefined,
                marginRight: "1px",
                "&$disabled": {
                    borderRight: undefined,
                },
            },
        },
        groupedContainedPrimary: {
            "&:not(:last-child)": {
                borderColor: undefined,
            },
        },
        groupedContainedSecondary: {
            "&:not(:last-child)": {
                borderColor: undefined,
            },
        },
    });
};
//# sourceMappingURL=MuiButtonGroup.js.map